import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Popover,
  Avatar,
  TextField,
  InputAdornment
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Search } from "@mui/icons-material";

const AssignUserPopover = ({
  open,
  anchorEl,
  handleClose,
  search,
  setSearch,
  users,
  isLoading,
  onSelectUser
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          elevation: 0,
          width: 320,
          maxHeight: 400,
          display: "flex",
          flexDirection: "column",
          borderRadius: 1.5,
          boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          py: 0.2,
          px: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #eee",
          position: "sticky",
          top: 0,
          backgroundColor: "#ededed",
          zIndex: 1,
        }}
      >
        <Typography variant="subtitle2" fontWeight={600}>
          ASSIGN TASK TO
        </Typography>

        <IconButton size="small" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Search */}
      <Box sx={{ p: 0.5, borderBottom: "1px solid #eee" }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search by name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"><Search/></InputAdornment>
            ),
            endAdornment: search && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => setSearch("")}
                  edge="end"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Users List */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
        }}
      >
        {isLoading ? (
          <Typography sx={{ p: 2 }}>Loading...</Typography>
        ) : users?.length > 0 ? (
          users.map((user) => (
            <Box
              key={user.id}
              onClick={() => onSelectUser(user)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 1,
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <Avatar src={user?.image} sx={{ width: 24, height: 24 }}>
                {!user?.image && user?.label?.charAt(0)}
              </Avatar>

              <Typography variant="body2">{user?.label}</Typography>
            </Box>
          ))
        ) : (
          <Typography
            variant="body2"
            sx={{
              p: 2,
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            No users found
          </Typography>
        )}
      </Box>
    </Popover>
  );
};

export default AssignUserPopover;